import React, {useState, useEffect, useRef } from "react";
import {Link, useNavigate} from "react-router-dom";
import "pages/login/Login.css";
import passwordImage from "assets/images/icon/password.svg";
import axios from "axios";
import { LOGIN_API, NICE_CERT_ORIGIN } from "constants/apiUrls";
import {changePasswordApi, getShopLoginIdApi} from "../../api/loginApi";

const ResetPassword = () => {
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [loginIdCheck, setLoginIdCheck] = useState(false);
  const [loginId, setLoginId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [checked, setChecked] = useState(false);
  const [token, setToken] = useState("");
  const tokenRef = useRef("");  // 추가
  const userTypeRef = useRef(null);  // 추가
  const [userType, setUserType] = useState(null);  // 추가
  const [changeResult, setChangeResult] = useState(false);
  const navigate = useNavigate();

  // 아이디 체크
  const loginIdCheckEvent = async () => {
    const loginId = document.getElementById("loginId");
    const value = loginId.value;

    if (value.length > 0) {
      const searchDate = {
        channelType: 2,
        loginId: value
      }

      const getData = await getShopLoginIdApi(searchDate);

      if (getData.testResult) {
        setLoginId(value);
        setUserId(getData.userId);
        setLoginIdCheck(true);
        setError(false);
      } else {
        setLoginIdCheck(false);
        setError(true);
      }

      console.log(getData);
    } else {
      setLoginIdCheck(false);
      setError(true);
    }
  }

  // 나이스 인증 요청
  const checkEvent = async () => {
    try {
      const getToken = await axios.get(`${LOGIN_API}/cert/nice24`, {
        params: {
          channelType: 2,
          requiredPasswordToken: true,
          certType: 3,
          loginId: loginId
        },
      });

      // 새 창 열기 및 HTML 데이터 쓰기
      const newWindow = window.open("", "_blank", "width=400,height=400");
      newWindow.document.open();
      newWindow.document.write(getToken.data);
      newWindow.document.close();

    } catch (error) {
      console.error("Error fetching token:", error);
    }
  };

  // 비밀번호 변경
  const passwordCheck = async () => {
    const pw1 = document.getElementById("pw1");
    const pw2 = document.getElementById("pw2");

    if (pw1.value.length < 8) {
      setErrorText("8자리 이상 입력해주세요.");
      return false;
    }

    if (!isPasswordValid(pw1.value)) {
      setErrorText("영어, 숫자, 특수문자 조합으로 입력해주세요.");
      return false;
    }

    if (pw1.value !== pw2.value) {
      setErrorText("비밀번호가 불일치합니다.");
      return false;
    }

    setErrorText("");

    const passwordDate = {
      channelType: 2,
      userType: userTypeRef.current,
      loginId: loginId,
      newPassword: pw1.value
    }


    await changePasswordApi(userId, passwordDate, tokenRef.current);
    setChangeResult(true);
  }

  const isPasswordValid = (password) => {
    const hasCase = /[a-zA-Z]/.test(password);  // 영어 포함 여부 확인
    const hasNumber = /[0-9]/.test(password);     // 숫자 포함 여부 확인
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>_-]/.test(password);   // 특수문자 포함 여부 확인

    return hasCase && hasNumber && hasSpecialChar;
  };

  const handleMessage = (event) => {
    // console.log("수신된 origin:", event.origin);
    // console.log("기대하는 origin:", NICE_CERT_ORIGIN);
    // console.log("수신된 data:", event.data);

    // console.log(event.origin)
    if (event.origin !== NICE_CERT_ORIGIN) return;
    const payload = JSON.parse(atob(event.data.passwordToken.split('.')[1]));  // 추가
    
    setToken(event.data.passwordToken);
    setUserType(Number(payload.userType));  // 추가
    setChecked(true);
};

  useEffect(() => {
    tokenRef.current = token;
    userTypeRef.current = userType;
  }, [token, userType]);


  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);  // 클린업
    };
  }, []);



  console.log(loginId);
  console.log(userId);

  return (
    <main className="wt-full ht-full d-flex a-center j-center">
      <div className="findBox br-10">
        <div className="tapBox d-flex a-center j-between">
          <Link className="d-block ta-center fs-20" to="/v2/findId">아이디 찾기</Link>
          <Link className="d-block ta-center fs-20 active" to="/v2/resetPassword">비밀번호 변경</Link>
        </div>
        {!changeResult ?
          <div className="findBody">
            {!checked ?
              <>
                <div className="bizBox">
                  <p className="fs-18 fw-7 mb-10">아이디 조회</p>
                  <div className="biz d-flex a-center j-left">
                    <input
                      type='text'
                      className={`text number businessNumber fw-5 ${error ? "redBorder" : ""}`}
                      name="loginId"
                      id="loginId"
                      maxLength="30"
                      placeholder="아이디 입력"
                      onInput={(e) => {
                        if (e.target.value.length > e.target.maxLength)
                          e.target.value = e.target.value.slice(0, e.target.maxLength);
                      }}
                    />
                    <button
                      className="fw-5"
                      onClick={loginIdCheckEvent}
                    >
                      조회
                    </button>
                  </div>
                  <p className={`fs-12 fc-red mt-5 ${error ? "" : "d-none"}`}>일치하는 아이디 정보가 없습니다.</p>
                </div>

                <button
                  className={`fc-white fs-20 fw-7 br-10 ${loginIdCheck ? "bg-blue" : "bg-gray2"}`}
                  onClick={checkEvent}
                  disabled={!loginIdCheck}
                >
                  NICE 인증으로 비밀번호 변경
                </button>
              </> :
              <>
                <div className="passwordBox mb-50">
                  <p className="fw-7 fs-18 mb-5">새로운 비밀번호 입력</p>
                  <div className={`pwInput br-6 d-flex a-center j-left ${errorText !== "" ? "redBorder" : ""}`}>
                    <img src={passwordImage} alt="password"/>
                    <input id="pw1" type="password" maxLength={16} />
                  </div>
                  <p className="fw-7 fs-18 mb-5">비밀번호 재입력</p>
                  <div className={`pwInput br-6 d-flex a-center j-left ${errorText !== "" ? "redBorder" : ""}`}>
                    <img src={passwordImage} alt="password"/>
                    <input id="pw2" type="password" maxLength={16} />
                  </div>
                  <p className={`fs-12 fc-red mt-5 ${errorText !== "" ? "" : "d-none"}`}>{errorText}</p>
                </div>
                <button
                  className="fc-white fs-20 fw-7 br-10 bg-blue"
                  onClick={passwordCheck}
                >
                  완료
                </button>
              </>
            }


            {/*{!checked ?
            <button className="bg-blue fc-white fs-20 fw-7 br-10" onClick={checkEvent}>NICE 인증으로 비밀번호 찾기</button> :
            <>
              {idChecked ?
                <div className="passwordBox mb-50">
                  <p className="fw-7 fs-18 mb-5">새로운 비밀번호 입력</p>
                  <div className="pwInput mb-20 br-6 d-flex a-center j-left">
                    <img src={passwordImage} alt="password"/>
                    <input id="pw1" type="password" maxLength={16} onChange={passwordCheck} />
                  </div>
                  <p className="fw-7 fs-18 mb-5">비밀번호 재입력</p>
                  <div className="pwInput br-6 d-flex a-center j-left">
                    <img src={passwordImage} alt="password"/>
                    <input id="pw2" type="password" maxLength={16} onChange={passwordCheck} />
                  </div>
                </div> :
                <>
                  <p className="fs-18 fw-7 mb-15">입력하신 정보로 비밀번호를 변경할 수 없습니다.</p>
                  <div className="idBox br-6 d-flex a-center j-left">
                    <div>
                      <p className="fw-5 fc-blue2">해당 정보로 등록된 계정이 없습니다.</p>
                      <p className="fw-5 fc-gray3">도움이 필요하시면 고객센터(1800-9991)로 연락해 주세요.</p>
                    </div>
                  </div>
                </>
              }

              <button className="bg-blue fc-white fs-20 fw-7 br-10" onClick={() => navigate("/")}>
                {idChecked ? "완료" : "로그인 화면으로 돌아가기"}
              </button>
            </>
          }*/}
          </div> :
          <div className="findBody">
            <div className="idBoxList scrollbar">
              <div className="idBox idBox2 br-6 d-flex a-center j-left">
                <div>
                  <p className="fw-7 fs-20">비밀번호 변경이 완료되었습니다!</p>
                  <p className="fw-7 fs-20 fc-blue2">새로운 비밀번호로 안전하게 로그인해 주세요.</p>
                </div>
              </div>
            </div>
            <button className="bg-blue fc-white fs-20 fw-7 br-10" onClick={() => navigate("/")}>
              로그인 하기
            </button>
          </div>
        }
      </div>
    </main>
  );
};

export default ResetPassword;